import React, { useState } from 'react';
import { auth } from './firebaseConfig';
import { sendPasswordResetEmail } from 'firebase/auth';
import { TextField, Button, Typography, Stack, Box } from '@mui/material';

const ForgotPasswordComponent = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleForgotPassword = async () => {
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Si el correo está registrado, recibirás un enlace para restablecer la contraseña.');
    } catch (error) {
      console.error('Error al enviar el correo de restablecimiento:', error);
      setMessage('Hubo un error al intentar enviar el correo.');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Restablecer Contraseña</Typography>
      <Stack spacing={2}>
        <TextField
          type="email"
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
        />
        <Button variant="contained" color="primary" onClick={handleForgotPassword}>
          Enviar Correo de Restablecimiento
        </Button>
        <Button color="secondary" onClick={onBack}>
          Volver
        </Button>
        {message && (
          <Typography variant="body2" color="success.main">
            {message}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

export default ForgotPasswordComponent;
